// extracted by mini-css-extract-plugin
export default {"dialog":"PortalLogoutButton_dialog__sxs60","title":"PortalLogoutButton_title__X5V4j","actions":"PortalLogoutButton_actions__s1NG-"};